//@flow
import * as actionTypes from './actionTypes';
import {
    submitTaskApi,getTaskApi,getVendorsApi
} from '../../apiUtils/api';
import type { Dispatch,ReducerState$Type,PostPayloadData } from './flowTypes'
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from '../demeter/submitFormData'

export const getTaskData=(leto:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch) => getTaskApi(jwt,'Leto',taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.LETO_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformDataToEditFormData(data,leto)
            dispatch({
                type: actionTypes.LETO_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.LETO_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.LETO_INV_SUBMITTED_COMPLETED };
}

export const invoiceSubmission = (jwt:any,taskAcceptedInfoId:number,letoResultset:any,eros:ReducerState$Type)=>{
    let payload:PostPayloadData={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (letoResultset.isInvalidDoc){
        payload.isInvalidDoc=true;
    }else {
        payload.vendorName=letoResultset.vendorName;
        payload.invNo=letoResultset.invNo;
        payload.invDate=letoResultset.invDate;
        payload.itemTotal=letoResultset.itemTotal;
        payload.total=letoResultset.total;
        payload.isInvalidDoc=letoResultset.isInvalidDoc?letoResultset.isInvalidDoc:false;
        payload.poNo=letoResultset.poNo?letoResultset.poNo:'';
        payload.isOverrideVendorName=letoResultset.isOverrideVendorName?letoResultset.isOverrideVendorName:false;
    }

    if (eros.reviewQuestions && eros.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(letoResultset,eros.reviewQuestions)
    }
    
    return (dispatch:Dispatch) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.LETO_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.LETO_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.LETO_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.LETO_UPDATE_FORM_ERROR, formError: error }
}

export const populateVendorsList=(jwt:any)=>{
    return (dispatch:Dispatch) => getVendorsApi(jwt,'Leto').then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.REFRESH_LETO_VENDORS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_LETO_VENDORS_SUCCESS, vendors: data.vendors });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_LETO_VENDORS_ERROR, error: err});
    })
}


// WEBPACK FOOTER //
// ./src/redux/leto/actions.js